import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useCurrentUserDetails } from 'entities/user/model';
import { useCallback } from 'react';

export const useOrgIntegrations = () => {
  const { getCurrentOrganizationId } = useCurrentUserDetails();
  const { getAccessTokenSilently } = useAuth0();
  const query = useQuery({
    queryKey: ['org-integrations'],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const resp = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/api/public/organisation/integrations/list`,
        {
          params: {
            organizationId: getCurrentOrganizationId(),
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return resp.data?.result;
    },
    enabled: !!getCurrentOrganizationId(),
  });

  const getQBOIntegration = useCallback(() => {
    return query.data?.find((i: any) => i.type === 'quick_books_online');
  }, [query.data]);

  return {
    getQBOIntegration,
  };
};
